var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutDeco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 400,
    viewBox: "0 0 414 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.491 357.147C112.76 342.863 82.5669 319.349 55.8682 268.882C31.1863 222.227 17.5695 182.334 34.2288 131.166C52.8984 73.8244 93.7415 49.4805 146.513 42.7235C209.916 34.6054 256.379 69.1726 290.754 131.166C328.485 199.211 343.927 285.452 290.754 338.005C252.398 375.914 211.502 371.224 162.491 357.147Z",
    fill: "url(#paint0_linear_446_4245)",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.656 394.816C106.652 377.8 62.3314 349.79 23.1393 289.673C-13.0921 234.097 -1.31547 133.226 23.1393 72.2752C50.545 3.96919 156.047 -14.958 239.971 11.4199C303.528 31.3959 317.476 51.7783 367.937 125.626C423.323 206.681 437.644 278.351 359.59 340.953C303.286 386.11 251.6 411.584 179.656 394.816Z",
    fill: "url(#paint1_linear_446_4245)",
    fillOpacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.533 287.046C120.885 278.292 99.2428 263.88 80.1051 232.948C62.4132 204.353 52.6527 179.902 64.594 148.542C77.9764 113.397 107.253 98.4763 145.08 94.335C190.526 89.3594 223.831 110.546 248.471 148.542C275.517 190.247 286.586 243.104 248.471 275.314C220.978 298.548 191.664 295.674 156.533 287.046Z",
    fill: "url(#paint2_linear_446_4245)",
    fillOpacity: 0.35
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_446_4245",
    x1: 175.988,
    y1: 367.459,
    x2: 175.988,
    y2: 41.5521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#297DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5055B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_446_4245",
    x1: 196.29,
    y1: 400.8,
    x2: 196.29,
    y2: 12.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#297DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5055B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_446_4245",
    x1: 166.207,
    y1: 293.367,
    x2: 166.207,
    y2: 93.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#297DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5055B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A31"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutDeco);
export default __webpack_public_path__ + "static/media/about-deco.c17562cde76825cbb4bd0e80ac2b151d.svg";
export { ForwardRef as ReactComponent };